import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_txyh6s2xzf: FaireCollectionEntity = {
  token: "pbc_txyh6s2xzf",
  type: "collection",
  name: "notepads",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2841cca31c511038a849c7a685dde62de9773ab35c43679fe454f305129ab724.jpeg",
  itemCount: 3,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.763Z",
    importedBy: "entity-db-import-collections",
  },
};
